// lib/text/discreetTypography.tsx
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var StyledBuildNumber = styled(Typography)`
  display: 'flex';
  justifycontent: 'center';
  padding: 2;
`;
var DiscreetTypography = ({ className, sx, children }) => {
  return /* @__PURE__ */ jsx(StyledBuildNumber, { className, sx, variant: "caption", children });
};

export {
  DiscreetTypography
};
